import React from 'react'

import { BodyText } from '@/components/core/BodyText'
import { Button } from '@/components/core/Button'
import { ReloadIcon } from '@/components/core/Icon/icons'

import './index.scss'

export interface ErrorWithRetryProps {
  error: string
  onRetry?: () => void
  retryButtonText?: string
}

export function ErrorWithRetry({ error, onRetry, retryButtonText = 'Try again' }: ErrorWithRetryProps) {
  return (
    <div className="error-with-retry">
      <div className="error-with-retry__content">
        <BodyText>{error}</BodyText>
        {onRetry && (
          <Button variant="primary-light" size="small" onClick={onRetry} style={{ width: '130px' }}>
            <ReloadIcon className="error-with-retry__icon" />
            {retryButtonText}
          </Button>
        )}
      </div>
    </div>
  )
}
